"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.game_manager = exports.KHGameManager = exports.Controls = exports.set_scale = exports.game = void 0;
const KHInputKeyCompeting_1 = require("./KH/Input/Key/KHInputKeyCompeting");
const KHInputKeyRepeating_1 = require("./KH/Input/Key/KHInputKeyRepeating");
const KHController_1 = require("./KH/Input/KHController");
const KHInputProviderController_1 = require("./KH/Input/KHInputProviderController");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHInputSet_1 = require("./KH/Input/KHInputSet");
const KHUnifiedInput_1 = require("./KH/Input/KHUnifiedInput");
const KHAudioScene_1 = require("./KH/KHAudioScene");
const KHRandom_1 = require("./KH/KHRandom");
const TSEndScene_1 = require("./TSEndScene");
const TSGameMatch_1 = require("./TSGameMatch");
const TSGameNormal_1 = require("./TSGameNormal");
const TSGameScene_1 = require("./TSGameScene");
const TSGameSnake_1 = require("./TSGameSnake");
const TSGameTron_1 = require("./TSGameTron");
const TSMediatingScene_1 = require("./TSMediatingScene");
const TSMenuScene_1 = require("./TSMenuScene");
const TSOptions_1 = require("./TSOptions");
const TSPreloadScene_1 = require("./TSPreloadScene");
const config = {
    type: Phaser.AUTO,
    scale: {
        width: 64,
        height: 64,
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
    },
    input: {
        gamepad: true,
    },
    disableContextMenu: true,
    parent: "phaser-game",
    version: "1.0.0",
    pixelArt: true,
    zoom: TSOptions_1.global_options.scale.get(),
    scene: [TSPreloadScene_1.TSPreloadScene, TSMediatingScene_1.TSMediatingScene, TSEndScene_1.TSEndScene, TSGameScene_1.TSGameScene, TSMenuScene_1.TSMenuScene, KHInputScene_1.KHInputScene, KHAudioScene_1.KHAudioScene]
};
exports.game = new Phaser.Game(config);
document.addEventListener("keydown", e => {
    if (e.key == "+" || e.key == "=") {
        set_scale(TSOptions_1.global_options.scale.get() + 1);
    }
    if (e.key == "-") {
        set_scale(TSOptions_1.global_options.scale.get() - 1);
    }
    if (e.key == 'm') {
        TSOptions_1.global_options.mute.set(!TSOptions_1.global_options.mute.get());
        exports.game.sound.mute = TSOptions_1.global_options.mute.get();
    }
    if (e.key == 'c') {
        TSOptions_1.global_options.colorblind.set(!TSOptions_1.global_options.colorblind.get());
    }
});
function set_scale(scale) {
    scale = Math.min(10, Math.max(1, scale));
    TSOptions_1.global_options.scale.set(scale);
    console.log("set scale " + scale);
    exports.game.canvas.style.width = (64 * scale).toString() + 'px';
    exports.game.canvas.style.height = (64 * scale).toString() + 'px';
}
exports.set_scale = set_scale;
var Controls;
(function (Controls) {
    Controls[Controls["Up"] = 0] = "Up";
    Controls[Controls["Down"] = 1] = "Down";
    Controls[Controls["Left"] = 2] = "Left";
    Controls[Controls["Right"] = 3] = "Right";
    Controls[Controls["Enter"] = 4] = "Enter";
})(Controls = exports.Controls || (exports.Controls = {}));
class KHGameManager {
    constructor(game) {
        this.game = game;
    }
    add_or_get_audio_scene(scene) {
        if (this._audio == null) {
            scene.scene.run("KHAudioScene");
            this._audio = scene.scene.get("KHAudioScene");
        }
        return this._audio;
    }
    getController() {
        if (this._controller != null)
            return this._controller;
        const inputSet = new KHInputSet_1.KHInputSet("controller");
        const inputMap = new Map();
        const das = 250;
        const arr = 200;
        const left = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.A], [KHInputProviderController_1.KHPadInput.Left]);
        const right = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.D], [KHInputProviderController_1.KHPadInput.Right]);
        const competingLeft = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, left, right, false), das, arr);
        const competingRight = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, right, left, true), das, arr);
        const up = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.W], [KHInputProviderController_1.KHPadInput.Up]);
        const down = KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.DOWN, Phaser.Input.Keyboard.KeyCodes.S], [KHInputProviderController_1.KHPadInput.Down]);
        const competingUp = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, up, down, false), das, arr);
        const competingDown = new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, new KHInputKeyCompeting_1.KHInputKeyCompeting(inputSet, down, up, true), das, arr);
        inputMap.set(Controls.Left, competingLeft);
        inputMap.set(Controls.Right, competingRight);
        inputMap.set(Controls.Up, competingUp);
        inputMap.set(Controls.Down, competingDown);
        inputMap.set(Controls.Enter, new KHInputKeyRepeating_1.KHInputKeyRepeating(inputSet, KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.ENTER, Phaser.Input.Keyboard.KeyCodes.SPACE], [KHInputProviderController_1.KHPadInput.A, KHInputProviderController_1.KHPadInput.Start]), 200, 200));
        this._controller = new KHController_1.KHController(inputMap, new Map(), inputSet);
        return this._controller;
    }
    getGames() {
        if (this._games === undefined) {
            this._games = [
                () => new TSGameNormal_1.TSGameMaze(),
                () => new TSGameNormal_1.TSGameRiver(),
                () => new TSGameNormal_1.TSGameRoad(),
                () => new TSGameNormal_1.TSGameBoulderRoll(),
                () => new TSGameNormal_1.TSGameBoulderFall(),
                () => new TSGameNormal_1.TSGameBlockPush(),
                () => new TSGameNormal_1.TSGameChase(),
                () => new TSGameNormal_1.TSGameIceSlide(),
                () => new TSGameNormal_1.TSGameMirror(),
                () => TSGameMatch_1.TSGameMatch.SameCol(),
                () => TSGameMatch_1.TSGameMatch.SameRow(),
                () => TSGameMatch_1.TSGameMatch.DifferentAll(),
                () => TSGameMatch_1.TSGameMatch.DifferentCol(),
                () => TSGameMatch_1.TSGameMatch.DifferentRow(),
                () => TSGameMatch_1.TSGameMatch.Rainbow(),
                () => TSGameTron_1.TSGameTron.TwoPlayer(),
                () => TSGameTron_1.TSGameTron.ThreePlayer(),
                () => new TSGameSnake_1.TSGameSnakeBasic(),
                () => new TSGameSnake_1.TSGameSnakeLong(),
            ];
            const seed = TSOptions_1.global_save.seed.get();
            const rand = new KHRandom_1.KHRandomSeedable(seed);
            rand.shuffleArray(this._games);
            this._games.unshift(() => new TSGameNormal_1.TSGameTutorial());
            // this._games.unshift(() => new TSGameSnakeLong())
        }
        return this._games;
    }
}
exports.KHGameManager = KHGameManager;
exports.game_manager = new KHGameManager(exports.game);
